

































import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
  },
})
export default class PageAccountsShow extends Vue {
  @Getter('account/viewing') account!: PimAccount[];

  @Action('account/update') updateAccount!: (payload: PimAccount) => Promise<PimAccount>;

  i18n: string = 'views.accounts.show';

  $refs!: Vue['$refs'] & {
    accountForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: PimAccount = {
    first_name: '',
    last_name: '',
    locale: 'nl_BE',
    reseller_id: null,
  };

  private handleSubmit() {
    if (!this.payload.id) {
      return;
    }

    this.updateAccount(this.payload)
      .then((account: PimAccount) => this.$refs.accountForm.handleSuccess())
      .catch((e: ErrorResponse) => this.$refs.accountForm.handleErrors(e));
  }

  @Watch('account', { immediate: true, deep: true })
  private handleModelChanged(val: PimAccount) {
    if (!val) {
      return undefined;
    }

    this.payload = JSON.parse(JSON.stringify(val));
  }
}
